// ======================================================================
// 📞 SISTEMA GLOBAL DE WHATSAPP — CLICK SORVETES
// Local: /src/utils/core/whatsappGlobal.js
// Fonte única de verdade para integração com WhatsApp
// ======================================================================

import { siteInfo } from "@/config/siteInfo";

// ======================================================================
// 1. 🔔 ABRIR POPUP GLOBAL DE WHATSAPP (quando aplicável)
// ======================================================================
export function abrirPopupWhatsGlobal(assuntoValue = null) {
  window.dispatchEvent(
    new CustomEvent("abrirWhatsComAssunto", {
      detail: assuntoValue ? { value: assuntoValue } : {},
    }),
  );
}

// ======================================================================
// 2. 🎧 REGISTRAR OUVINTE GLOBAL (PopupWhatsApp)
// ======================================================================
export function registrarOuvirWhatsGlobal({ assuntos, selecionados, popupAberto }) {
  const handle = (e) => {
    const assuntoValue = e.detail?.value;
    const assuntoEncontrado = assuntos.find((a) => a.value === assuntoValue);

    selecionados.value = assuntoEncontrado ? [assuntoEncontrado] : [];
    popupAberto.value = true;
  };

  window.addEventListener("abrirWhatsComAssunto", handle);

  return () => window.removeEventListener("abrirWhatsComAssunto", handle);
}

// ======================================================================
// 3. 📤 REDIRECIONAMENTO PARA PÁGINA DE OBRIGADO (CONVERSÃO)
// ======================================================================
export function enviarParaObrigado(listaSelecionados = []) {
  try {
    const valores = listaSelecionados.map((a) => a.value);
    const sel = JSON.stringify(valores);

    window.location.href = `/obrigado?sel=${encodeURIComponent(sel)}`;
  } catch (err) {
    console.error("Erro ao enviar para página de obrigado:", err);
  }
}

// ======================================================================
// 4. 🧠 GERAR MENSAGEM PADRONIZADA DE EVENTO (TEXTO)
// ======================================================================
import { brl } from "@/utils/core/formatters";

export function gerarMensagemWhatsAppEvento(resumo = {}) {
  if (!resumo || typeof resumo !== "object") return "";

  const dataBR = resumo.data ? new Date(`${resumo.data}T00:00:00`).toLocaleDateString("pt-BR") : "-";

  const montarEndereco = (e) => {
    if (!e || !e.endereco) return "-";

    const linhas = [];
    if (e.endereco.logradouro) linhas.push(e.endereco.logradouro);
    if (e.numero) linhas.push(`Nº ${e.numero}`);
    if (e.endereco.bairro) linhas.push(e.endereco.bairro);
    if (e.endereco.localidade || e.endereco.uf) linhas.push(`${e.endereco.localidade}/${e.endereco.uf}`);
    if (e.cep) linhas.push(`CEP ${e.cep}`);
    return linhas.join("\n");
  };

  const montarItens = (itens = []) => {
    const blocos = [];

    // ✅ VALOR DA DURAÇÃO (robusto)
    const duracaoTexto = resumo.duracao || "";
    const valorDuracao =
      Number(
        resumo.valorDuracao ??
          resumo.valorAdicionalHoras ?? // <- seu nome atual no projeto
          resumo.valorAdicionalHorasDuracao ??
          resumo.duracaoValor ??
          resumo.duracaoObj?.valorAdicional,
      ) || 0;

    if (duracaoTexto) {
      blocos.push(`* Duração do evento — 1 serviço\n` + `  ${duracaoTexto}  -  ${brl(valorDuracao)}`);
    }

    if (!Array.isArray(itens) || !itens.length) {
      return blocos.join("\n\n");
    }

    itens.forEach((item) => {
      const linhas = [];
      const qtd = item.quantidade || 1;
      const totalItem = (item.preco || 0) * qtd;

      linhas.push(`* ${item.nome} — ${qtd} un.`);

      const detalhes = [];
      if (item.rendimentoTotal) detalhes.push(`Rendimento: ${item.rendimentoTotal}`);
      detalhes.push(brl(totalItem));

      linhas.push(`  ${detalhes.join("  -  ")}`);

      if (Array.isArray(item.sabores) && item.sabores.length) {
        linhas.push(`  Sabores:`);
        item.sabores.forEach((s) => {
          linhas.push(`  ${s.nome} (${s.quantidade})`);
        });
      }

      blocos.push(linhas.join("\n"));
    });

    return blocos.join("\n\n");
  };

  return `
*SOLICITAÇÃO DE EVENTO*

Orçamento nº ${resumo.numeroOrcamento || "-"}


*EVENTO*

Data: ${dataBR}
Horário: ${resumo.hora || "-"}
Tipo: ${resumo.tipo || "-"}


*LOCAL*

${montarEndereco(resumo.endereco)}


*ITENS*

${montarItens(resumo.itens)}


*TOTAL ESTIMADO*

${brl(resumo.total)}


*OBSERVAÇÕES*

Frete não incluso. Será calculado após validação do endereço.


*PRÓXIMOS PASSOS*

1) Confirmar disponibilidade  
2) Calcular frete  
3) Fechar contratação
`.trim();
}

// ======================================================================
// 5. 🔗 GERAR LINK FINAL DE WHATSAPP (USAR SEMPRE ESTE)
// ======================================================================
export function gerarLinkWhatsAppEvento(resumo) {
  const numero = siteInfo?.whatsapp;

  if (!numero) {
    console.error("Número de WhatsApp não configurado em siteInfo");
    return "#";
  }

  const mensagem = gerarMensagemWhatsAppEvento(resumo);

  if (!mensagem) return "#";

  // wa.me é o formato correto (evita 404 no desktop)
  return `https://wa.me/55${numero}?text=${encodeURIComponent(mensagem)}`;
}

export function contatoWhatsAppLocacao({ produto = "Máquina de Sorvete Soft", meses = "", preco = "", cnpj = "", telefone = "5511915946319" } = {}) {
  const precoNum = Number(String(preco).replace(/[^\d]/g, "")) || 0;
  const precoBR = `R$ ${precoNum.toLocaleString("pt-BR")},00`;

  const msg = encodeURIComponent(`Olá! Quero reservar ${produto}.\n\n` + `Tempo de contrato: ${meses} meses\n` + `Valor mensal: ${precoBR}\n` + `CNPJ: ${cnpj}`);

  window.open(`https://wa.me/${telefone}?text=${msg}`, "_blank");
}

// ======================================================================
// 6. 📲 WHATSAPP DIRETO — LICENCIAMENTO (SEM POPUP / SEM EVENTO)
// ======================================================================

export function contatoWhatsAppLicenciamento() {
  const telefone = siteInfo?.whatsapp;
  const valor = siteInfo?.licenciamentoValor || "R$ 5.000,00";

  if (!telefone) {
    console.error("Telefone de WhatsApp não configurado em siteInfo");
    return;
  }

  const mensagem = encodeURIComponent(`Olá! Tenho interesse no Licenciamento Click Sorvetes.\n\n` + `Valor do licenciamento: ${valor}\n\n` + `Quero entender os próximos passos para fechar.`);

  window.open(`https://wa.me/55${telefone}?text=${mensagem}`, "_blank");
}
